import { useEffect } from "react";

const NOINDEX = "noindex, nofollow";

// Keeps ONE robots meta in the head: the page's existing
// <meta name="robots"> (index.html) gets "noindex, nofollow" (or the value
// passed, e.g. "noindex" on the 404 page) while the page is mounted and its
// old content back on unmount. A tag is created only when
// there is none, and removed again on unmount.
const useNoindex = (value = NOINDEX) => {
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    const existing = document.head?.querySelector?.('meta[name="robots"]') ?? null;
    if (existing) {
      const before = existing.getAttribute("content");
      existing.setAttribute("content", value);
      return () => {
        if (before === null) existing.removeAttribute("content");
        else existing.setAttribute("content", before);
      };
    }
    const meta = document.createElement("meta");
    meta.setAttribute("name", "robots");
    meta.setAttribute("content", value);
    document.head?.appendChild?.(meta);
    return () => {
      meta.remove();
    };
  }, [value]);
};

// Wrapper for routes whose page component does not call the hook itself
// (admin, client portal, login, signup; src/App.js).
export const Noindex = ({ children }) => {
  useNoindex();
  return children ?? null;
};

export default useNoindex;
